import clsx from 'clsx';
import React, { ReactNode } from 'react';

interface Props {
  onClick: () => void;
  icon?: JSX.Element;
  children: ReactNode;
  size?: 's' | 'm';
  color?: 'black' | 'primary';
  dataElementId?: string;
}

export default function ButtonLink({
  onClick,
  icon,
  children,
  size = 's',
  color = 'black',
  dataElementId
}: Props) {
  return (
    <button
      className={clsx('btn-link plain', size, color && 'btn-link-' + color)}
      onClick={onClick}
      data-element-id={dataElementId}
    >
      {icon}
      {children}
    </button>
  );
}
